export const translationEN = {
  'acronym': 'RJCM',
  'magazine_title': 'The Romanian Journal of Cultural Management ',
  'department_name': 'Department of Drama and Theatre Studies',
  'cavas_research_center': 'Advanced Research Centre for Studies in the Field of Performing Arts',
  'indexed-by': 'Publication indexed in:',
  'copyright': 'All rights reserved',
  affiliation: {
    'lucian_blaga_university_of_sibiu': 'Lucian Blaga University of Sibiu',
    'new_sorbonne_university_paris_3': 'New Sorbonne University Paris 3',
    'leeds_beckett_university': 'Leeds Beckett University',
  },
  title: {
    'president': 'PRESIDENT',
    'editor_in_chief': 'EDITOR-IN-CHIEF',
    'associate_editor': 'ASSOCIATE EDITOR',
    'managing_editor': 'MANAGING EDITOR',
    'web_and_print': 'WEB & PRINT',
  },
  position: {
    'univ_professor': 'Dr. Professor',
    'assoc_professor': 'Dr.',
    'phd_student': 'PhD Student'
  },
  menu: {
    'about': 'About',
    'boards': 'Boards',
    'instructions': 'Instructions',
    'review': 'Review',
    'call_for_papers': 'Call For Papers',
    'archive': 'Archive',
    'contact': 'Contact',
  },
  publicationList: {
    title: 'Title',
    year: 'Issue year',
    download: 'Download',
  },
  pages: {
    index: {
      description: 'The Romanian Journal of Cultural Management is an academic interdisciplinary and intercultural journal that is edited by Lucian Blaga University of Sibiu, through its Advanced Research Centre for Studies in the Field of Performing Arts. The journal covers aspects in the performing arts field of studies with a special focus on theatre, opera, dance, music, video, performance and also film. PAJ publishes articles written by renowned artists and theoreticians and also encourages young and emergent scholars to submit their articles. The special aim of PAJ is to encourage the theoretical dissemination of the practical work in the case of specialists engaged in performing arts.',
      latest_release_authors: 'Topics featured by:',
      partnership: {
        'part1': 'This magazine is issued by',
        'part2': 'CENTER OF ADVANCED RESEARCH IN THE FIELD OF PERFORMING ARTS',
        'part3': 'in partnership with',
        'part4': 'RADU STANCA NATIONAL THEATRE OF SIBIU',
        'part5': 'SIBIU INTERNATIONAL THEATRE FESTIVAL',
        'part6': 'DRAMA AND THEATRE STUDIES DEPARTMENT, FACULTY OF LETTERS AND ARTS',
        'part7': 'LUCIAN BLAGA UNIVERSITY OF SIBIU',
        'part8': 'and',
        'part9': 'LUCIAN BLAGA UNIVERSITY OF SIBIU PUBLISHING HOUSE'
      }
    },
    boards: {
      'sicentific_board': 'Scientific Board',
      'walk_of_fame': 'Walk of Fame',
      'editorial_board': 'Editorial Board'
    },
    instructions: {
      'part1': 'In order to ensure a unitary structure, as well as the formal quality our magazines require, please be aware of the following drafting requirements.',
      'part2': 'The papers will be saved in .doc or .docx format.',
      'part3': 'Scientific studies / articles concerning the area of the performing arts, visual arts or cultural management (between 5 and 15 pages);',
      'part4': 'Analysis / scientific review of a performance or film (between 5 and 15 pages).',
      'part5': 'The texts will be written in Romanian, English or French and they will be complemented by an abstract (90-100 words) and 5 keywords in English.',
      'part6': 'The name of the author, as well as his/her degree and affiliation, will be written on the first row of the first page and it will be linked to a footnote containing a short bio of the author (activity, professional training and affiliation).',
      'part7': 'Under the title of the text written with Bold, which will be centrally fixed on the first page, the abstract, then the keywords, will be placed.',
      'part8': 'The texts will be written on page format A4, in Times New Roman, the font size 12, to 1.5 lines, Justify. All the edges of the page must be 2.5cm.',
      'part9': 'Quotes will be inserted between quotation marks and the source will be indicated in footnotes, respecting this formula: Name of the author, Book title in italic, Translator (if applicable), Publishing house, Place of publication, Year of publication, Page. E.g: Eugenio Barba, Teatru: singurătate, meșteșug, revoltă. Translated by Doina Condrea Derer, Nemira Publishing House, București, 2013, p. 136.',
      'part10': 'In the case of quotes for online sources, the footnote will specify the author’s name, the article’s title and also the link for the specific source, together with the date of access.',
      'part11': 'The papers must have, at the end, a bibliography in alphabetical order written as follows:',
      'part12': 'In the case of books: Last name of the author, First name of the author, Book title, Publishing house, Place of publication, Year of publication.',
      'part13': 'In the case of articles in newspapers or magazines: Last name of the author, First name of the author, Title of the article, Title of the magazine / newspaper, Number, Month of appearance, Place of appearance, Year of appearance.',
      'part14': 'In the case of WEB articles: Last name of the author, First name of the author, Title of the article, Link to the article, date of access.',
      'part15': 'Please send your papers to the following email address: andrei.serban@ulbsibiu.ro.'
    },
    review: {
      'part1': 'The Romanian Journal of Cultural Management is a refereed journal.',
      'part2': 'All papers considered appropriate for this journal are reviewed anonymously by at least two outside reviewers. The reviewers are from different institution, not affiliated with the author’s institution.',
      'part3': 'The review process usually takes 4-6 weeks.',
    },
    call_for_papers: {
      'part1': 'Dear colleagues and collaborators,',
      'part2': 'We invite you to send your articles, studies and chronicles for the next The Romanian Journal of Cultural Management issue (year {{year}}, no. {{issueNumber}}) until {{date}}.',
      'part3': 'For further information concerning the content and the features of the papers to be sent, please take a look at the Instructions for Authors section.',      
    },
    archive: {
      'publishing': 'publishing',
    },
    contact: {
      'part1': 'Lucian Blaga University of Sibiu',
      'part2': 'Faculty of Letters and Arts',
      'part3': '5-7 Victoriei Blvd, 550024, Sibiu, Romania',
      'part4': 'https://artsib.ro',
      'part5': 'http://reviste.ulbsibiu.ro/jas',
      'part6': 'ion.tomus@ulbsibiu.ro',
      'part7': 'andrei.serban@ulbsibiu.ro'
    }
  }
}